import { decryptResponse, encryptResponse } from "../components/encryptResp";

const api_key = process.env.REACT_APP_API_KEY;

// Standardize response handling for all API calls
const handleApiResponse = async (response) => {
    try {
        const data = await response.json();
        return decryptResponse(data.encrypted, data.iv);
    } catch (error) {
        console.error('API Response Error:', error);
        return { status: false, message: "Internet Server Error" };
    }
};


// Controller
const getControlleClient = async () => {
    try {
        const resp = await fetch(`/api/app/controller/`, {
            method: "GET",
            headers: {
                'x-api-key': api_key
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getBannerClient = async () => {
    try {
        const resp = await fetch(`/api/app/banner`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getBannerClickClient = async (id) => {
    try {
        const resp = await fetch(`/api/app/banner/click/${id}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getReelsClient = async (page, limit) => {
    try {
        const resp = await fetch(`/api/app/story?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}
const viewPluseReelsClient = async (id) => {
    try {
        const resp = await fetch(`/api/app/story/view/${id}`, {
            method: "POST",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getCategoryClient = async (page, limit) => {
    try {
        const resp = await fetch(`/api/app/category/get/all?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}
const getCategoryClientByID = async (page, limit, id) => {
    try {
        const resp = await fetch(`/api/app/category/${id}?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}
const getProductClientByID = async (id) => {
    try {
        const resp = await fetch(`/api/app/list/${id}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}
const getPrompotClientByID = async (id) => {
    try {
        const resp = await fetch(`/api/app/list/prompt/${id}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Client
const setNotificationServer = async (body) => {
    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/notification/token`, {
            method: "POST",
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });

        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Search
const searchBar = async (q, page, limit) => {
    try {
        const resp = await fetch(`/api/app/list/by/search?q=${q}&page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
            },
        });

        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// CateAll List
const getCategoryList = async () => {
    try {
        const resp = await fetch(`/api/app/category/list/all`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
                'Content-Type': 'application/json',
            },
        });

        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Suggestion
const sendSuggestion = async (body) => {

    const encrypted = encryptResponse(body);
    try {
        const resp = await fetch(`/api/app/suggestion/send`, {
            method: "POST",
            headers: {

                'Content-Type': 'application/json',
                'x-api-key': api_key,
            },
            body: JSON.stringify({ encryptedData: encrypted }),
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Blog
const getBlog = async (page, limit) => {

    try {
        const resp = await fetch(`/api/app/blog/web?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {

                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getBlogId = async (id) => {

    try {
        const resp = await fetch(`/api/app/blog/web/${id}`, {
            method: "GET",
            headers: {

                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const getBlogSearch = async (q) => {

    try {
        const resp = await fetch(`/api/app/blog/search?query=${q}`, {
            method: "GET",
            headers: {

                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Blog Rendom
const getBlogRendom = async () => {
    try {
        const resp = await fetch(`/api/app/blog/random`, {
            method: "GET",
            headers: {

                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Blog By Title
const getBlogByTitle = async (id) => {
    try {
        const resp = await fetch(`/api/app/blog/web/title/${id}`, {
            method: "GET",
            headers: {
                'x-api-key': api_key,
            },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// ===== Wallpaper (public) =====

// All active categories (with preview image + counts)
const getWallpaperCategoryClient = async (page = 1, limit = 50, search = "") => {
    try {
        const resp = await fetch(
            `/api/app/wallpaper/category?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
            { method: "GET", headers: { 'x-api-key': api_key } }
        );
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Build the shared query string for the wallpaper feed endpoints
const wallpaperFeedQuery = (page, limit, opts = {}) => {
    const { category = "", search = "", sortBy = "", order = "", shuffle = false, seed } = opts;
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    if (category) params.set('category', category);
    if (search) params.set('search', search);
    if (sortBy) params.set('sortBy', sortBy);
    if (order) params.set('order', order);
    if (shuffle) params.set('shuffle', 'true');
    if (seed !== undefined && seed !== null) params.set('seed', seed);
    return params.toString();
}

// Main feed — all wallpapers across every active category
const getWallpaperListClient = async (page = 1, limit = 20, opts = {}) => {
    try {
        const resp = await fetch(
            `/api/app/wallpaper/list?${wallpaperFeedQuery(page, limit, opts)}`,
            { method: "GET", headers: { 'x-api-key': api_key } }
        );
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Wallpapers of one category (by slug)
const getWallpaperByCategoryClient = async (slug, page = 1, limit = 20, opts = {}) => {
    try {
        const resp = await fetch(
            `/api/app/wallpaper/list/${slug}?${wallpaperFeedQuery(page, limit, opts)}`,
            { method: "GET", headers: { 'x-api-key': api_key } }
        );
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// One wallpaper by slug — counts as a view (wallpaper +1, its category +1)
const getWallpaperBySlugClient = async (slug) => {
    try {
        const resp = await fetch(`/api/app/wallpaper/${slug}`, {
            method: "GET",
            headers: { 'x-api-key': api_key },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Autocomplete suggestions (wallpapers + categories) for the search box
const getWallpaperSuggestClient = async (q, limit = 8) => {
    try {
        const resp = await fetch(
            `/api/app/wallpaper/suggest?q=${encodeURIComponent(q)}&limit=${limit}`,
            { method: "GET", headers: { 'x-api-key': api_key } }
        );
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}


// ===== Inpix / Status maker (public) =====

// All active inpix categories (with preview image + counts), paginated + search
const getInpixCategoryClient = async (page = 1, limit = 30, search = "") => {
    try {
        const resp = await fetch(
            `/api/app/inpix/category?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
            { method: "GET", headers: { 'x-api-key': api_key } }
        );
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Shared query string for the inpix template feed endpoints
const inpixFeedQuery = (page, limit, opts = {}) => {
    const { type = "", search = "", sortBy = "", order = "", shuffle = false, seed } = opts;
    const params = new URLSearchParams();
    params.set('page', page);
    params.set('limit', limit);
    if (type) params.set('type', type);
    if (search) params.set('search', search);
    if (sortBy) params.set('sortBy', sortBy);
    if (order) params.set('order', order);
    if (shuffle) params.set('shuffle', 'true');
    if (seed !== undefined && seed !== null) params.set('seed', seed);
    return params.toString();
}

// Main feed — all templates across every active category
const getInpixListClient = async (page = 1, limit = 20, opts = {}) => {
    try {
        const resp = await fetch(
            `/api/app/inpix/template/list?${inpixFeedQuery(page, limit, opts)}`,
            { method: "GET", headers: { 'x-api-key': api_key } }
        );
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Templates of one category (by slug)
const getInpixByCategoryClient = async (slug, page = 1, limit = 20, opts = {}) => {
    try {
        const resp = await fetch(
            `/api/app/inpix/template/list/${slug}?${inpixFeedQuery(page, limit, opts)}`,
            { method: "GET", headers: { 'x-api-key': api_key } }
        );
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// One template by slug — includes connected frames; counts as a view
const getInpixBySlugClient = async (slug) => {
    try {
        const resp = await fetch(`/api/app/inpix/template/${slug}`, {
            method: "GET",
            headers: { 'x-api-key': api_key },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

// Record a template download (i_download_count +1)
const recordInpixDownloadClient = async (slug) => {
    try {
        const resp = await fetch(`/api/app/inpix/template/download/${slug}`, {
            method: "GET",
            headers: { 'x-api-key': api_key },
        });
        return handleApiResponse(resp);
    } catch (error) {
        return { status: false, message: "Internet Server Error" };
    }
}

const ClientCalling = {
    getControlleClient,
    getBannerClient,
    getBannerClickClient,
    getReelsClient,
    viewPluseReelsClient,
    getCategoryClient,
    getCategoryClientByID,
    getProductClientByID,
    getPrompotClientByID,
    setNotificationServer,
    searchBar,
    getCategoryList,
    sendSuggestion,
    getBlog, getBlogId, getBlogSearch, getBlogByTitle, getBlogRendom,
    getWallpaperCategoryClient,
    getWallpaperListClient,
    getWallpaperByCategoryClient,
    getWallpaperBySlugClient,
    getWallpaperSuggestClient,
    getInpixCategoryClient,
    getInpixListClient,
    getInpixByCategoryClient,
    getInpixBySlugClient,
    recordInpixDownloadClient,
}

export default ClientCalling;